import { localestr } from "./utils";
//export const ENGINE_URL = 'engine.php'
//export const ENGINE_URL = 'https://cocktail.pp.ua/pos/engine.php'
//export const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
//export var ENGINE_URL = 'https://cocktail.local/cocktail-front/engine.php'
 export var ENGINE_URL = "http://localhost/pos/engine.php";
 export var REPORT_URL = "http://localhost/pos/report.php";
 export var TERMINAL_URL = "http://localhost/pos/term.php";
//export var ENGINE_URL = "https://cocktail-4.e-menu.in.ua/pos/engine.php";
//export var REPORT_URL = "https://cocktail-4.e-menu.in.ua/pos/report.php";
//export var ENGINE_URL = "http://localhost:8000/engine.php";
//export var ENGINE_URL = 'https://cocktail-4.e-menu.in.ua/pos_stable/engine.php'
if (process.env.NODE_ENV === "production") ENGINE_URL = "engine.php";
if (process.env.NODE_ENV === "production") REPORT_URL = "report.php";

export const PAY_TYPES = {
    "0": localestr("Готівкою"),
    "1": localestr("Карткою"),
    "2": localestr("Liqpay"),
    "3": localestr("QR код моно"),
    "4": localestr("Сертифікат"),
    "6": localestr("По перерахунку"),
};

// New Themes
// #0 Shef
export const THEME_0 = {
    "--background": `no-repeat center center / cover url(${process.env.PUBLIC_URL}/bgw_1.svg), linear-gradient(340deg,#cdf0f0 -27.16%,#b3e5e7 100%)`,
    "--navbar-bg-color": "#ABD7D8",
    "--navbar-tx-color": "#000000",
    "--item-bg-color": "#96a2ad",
    "--item-border-color": "#96a2ad00",
    "--item-tx-color": "#fff",
    "--tbl1-bg-color": "#4e677d",
    "--tbl1-border-color": "#4e677d00",
    "--tbl1-tx-color": "#FFF",
    "--tbl2-bg-color": "#c6fdff",
    "--tbl2-border-color": "#85aeaf00",
    "--tbl2-tx-color": "#000",
    "--folder-bg-color": "#4e677d",
    "--folder-border-color": "#4e677d00",
    "--folder-tx-color": "#fff",
    "--toolbtn-bg-color": "#c6fdff",
    "--toolbtn-tx-color": "#000000",
    "--black-tx-color": "#000000",
    "--dark-tx-color": "#00000066",
    "--dark-btn-color": "#96a2ad88",
    "--modal-head-color": "#000000",
    "--modal-wnd-color": "#c9fbfd",
    "--modal-wnd-bg-color": "#eeffff",
    "--switch-on-color": "#000000",
    "--switch-off-color": "#FFFFFF",
    "--switch-bg-color": "#4e677d",
};

// #2 Pewter Blue
export const THEME_2 = {
    "--background": `no-repeat center center / cover url(${process.env.PUBLIC_URL}/bgw_1.svg), linear-gradient(341.85deg, #a4b9cf -27.16%, #95bae1 100%)`,
    "--navbar-bg-color": "#95bae1",
    "--navbar-tx-color": "#000000",
    "--item-bg-color": "#7b8d9e",
    "--item-border-color": "#7b8d9e00",
    "--item-tx-color": "#ffffff",
    "--tbl1-bg-color": "#507da5",
    "--tbl1-border-color": "#507da500",
    "--tbl1-tx-color": "#ffffff",
    "--tbl2-bg-color": "#b1ddff",
    "--tbl2-border-color": "#b1ddff00",
    "--tbl2-tx-color": "#000000",
    "--folder-bg-color": "#507da5",
    "--folder-border-color": "#507da500",
    "--folder-tx-color": "#ffffff",
    "--toolbtn-bg-color": "#b1ddff",
    "--toolbtn-tx-color": "#000000",
    "--black-tx-color": "#000000",
    "--dark-tx-color": "#00000066",
    "--dark-btn-color": "#00000033",
    "--modal-head-color": "#000000",
    "--modal-wnd-color": "#b9ddfa",
    "--modal-wnd-bg-color": "#d6e5f4",
    "--switch-on-color": "#000000",
    "--switch-off-color": "#ffffff",
    "--switch-bg-color": "#507da5",
};

// #3 Smoke Lavender
export const THEME_3 = {
    "--background": `no-repeat center center / cover url(${process.env.PUBLIC_URL}/bgw_1.svg), linear-gradient(341.85deg, #cdc5e9 -27.16%, #baafe8 100%)`,
    "--navbar-bg-color": "#baafe8",
    "--navbar-tx-color": "#000000",
    "--item-bg-color": "#808599",
    "--item-border-color": "#80859900",
    "--item-tx-color": "#ffffff",
    "--tbl1-bg-color": "#64618a",
    "--tbl1-border-color": "#64618a00",
    "--tbl1-tx-color": "#ffffff",
    "--tbl2-bg-color": "#e9dcff",
    "--tbl2-border-color": "#e9dcff00",
    "--tbl2-tx-color": "#000000",
    "--folder-bg-color": "#64618a",
    "--folder-border-color": "#64618a00",
    "--folder-tx-color": "#ffffff",
    "--toolbtn-bg-color": "#e9dcff",
    "--toolbtn-tx-color": "#000000",
    "--black-tx-color": "#000000",
    "--dark-tx-color": "#00000066",
    "--dark-btn-color": "#00000033",
    "--modal-head-color": "#000000",
    "--modal-wnd-color": "#dac5ff",
    "--modal-wnd-bg-color": "#fcf9ff",
    "--switch-on-color": "#000000",
    "--switch-off-color": "#ffffff",
    "--switch-bg-color": "#64618a",
};

// Old Themes
export const THEME1 = {
    "--background": `linear-gradient(341.85deg, #E3E3E3 -27.16%, #B5D7D8 100%)`,
    "--navbar-bg-color": "#B5D7D8",
    "--navbar-tx-color": "#000",
    "--black-tx-color": "#000",
    "--dark-tx-color": "#0006",
    "--dark-btn-color": "#0003",
    "--tbl1-bg-color": "#484C4CBF",
    "--tbl1-border-color": "#484C4CB2",
    "--tbl1-tx-color": "#FFF",
    "--tbl2-bg-color": "#466347E5",
    "--tbl2-border-color": "#466347E5",
    "--tbl2-tx-color": "#FFF",
    "--folder-border-color": "#0000",
    "--folder-bg-color": "#646C64",
    "--folder-tx-color": "#FFF",
    "--item-border-color": "#0000",
    "--item-bg-color": "#646C64B2",
    "--item-tx-color": "#FFF",
    "--toolbtn-bg-color": "#FFFFFF80",
    "--toolbtn-tx-color": "#000",
    "--modal-head-color": "#000",
    "--modal-wnd-color": "#C7DAE9",
    "--modal-wnd-bg-color": "#FFF",
    "--switch-on-color": "#646C64",
    "--switch-off-color": "#FFF",
    "--switch-bg-color": "#C7DAE9",
};

export const THEME2 = {
    "--background": "no-repeat url(../../bgw.svg) #E6EEFF 100% top",
    //"--navbar-bg-color": "linear-gradient(0deg, #4B286A  0, #673889 50%, #8D45B5)",
    "--navbar-bg-color": "linear-gradient(0deg, #4b388a, #6748a9 50%, #8d55d5)",
    "--navbar-tx-color": "#FFF",
    "--black-tx-color": "#000",
    "--dark-tx-color": "#0006",
    "--dark-btn-color": "#0003",
    //"--tbl1-bg-color": "linear-gradient(0deg,#4b286a,#673889 50%,#8d45b5)",
    "--tbl1-bg-color": "linear-gradient(0deg, #4b388a, #6748a9 50%, #8d55d5)",
    "--tbl1-border-color": "1px solid #F5AB00",
    "--tbl1-tx-color": "#FFF",
    "--tbl2-bg-color": "linear-gradient(to top, #DB8400 0%, #F5AB00 30%, #FCCA02 100%)",
    "--tbl2-border-color": "1px solid #F5AB00",
    "--tbl2-tx-color": "#000",
    "--folder-border-color": "#0000",
    //"--folder-bg-color": "linear-gradient(0deg,#4b286a,#673889 50%,#8d45b5)",
    "--folder-bg-color": "linear-gradient(0deg, #4b388a, #6748a9 50%, #8d55d5)",
    "--folder-tx-color": "#FFF",
    "--item-border-color": "#997579",
    "--item-bg-color": "linear-gradient(0deg,#855B5D 0,#997579 30%,#B39396)",
    "--item-tx-color": "#FFF",
    "--toolbtn-bg-color": "#FFFFFF80",
    "--toolbtn-tx-color": "#000",
    "--modal-head-color": "#FFF",
    //"--modal-wnd-color": "linear-gradient(180deg,#8d45b5 0,#673889 16px,#4b286a)",
    "--modal-wnd-color": "linear-gradient(180deg,#8d55d5 0,#6748a9 16px,#4b388a)",
    "--modal-wnd-bg-color": "#eef",
    "--switch-on-color": "radial-gradient(farthest-corner at 7px 4px,#ffffff -25%,#8d55d5 25%,#6748a9 75%,#4b388a)",
    "--switch-off-color": "#cabbeb",
    "--switch-bg-color": "#8d55d544",
};

export const THEME3 = {
    "--background": "linear-gradient(341.85deg, #434343 -27.16%, #252728 100%)",
    "--navbar-bg-color": "linear-gradient(0deg,#4B286A  0,#673889 50%,#8D45B5)",
    "--navbar-tx-color": "#FFF",
    "--black-tx-color": "#FFF9",
    "--dark-tx-color": "#FFF8",
    "--dark-btn-color": "#0003",
    "--tbl1-bg-color": "linear-gradient(0deg,#4b286a,#673889 50%,#8d45b5)",
    "--tbl1-border-color": "1px solid #F5AB00",
    "--tbl1-tx-color": "#FFF",
    "--tbl2-bg-color": "linear-gradient(to top, #DB8400 0%, #F5AB00 30%, #FCCA02 100%)",
    "--tbl2-border-color": "1px solid #F5AB00",
    "--tbl2-tx-color": "#000",
    "--folder-border-color": "#0000",
    "--folder-bg-color": "linear-gradient(0deg,#4b286a,#673889 50%,#8d45b5)",
    "--folder-tx-color": "#FFF",
    "--item-border-color": "#997579",
    "--item-bg-color": "linear-gradient(0deg,#855B5D 0,#997579 30%,#B39396)",
    "--item-tx-color": "#FFF",
    "--toolbtn-bg-color": "#00000080",
    "--toolbtn-tx-color": "#FFF",
    "--modal-head-color": "#FFF",
    "--modal-wnd-color": "linear-gradient(180deg,#8d45b5 0,#673889 16px,#4b286a)",
    "--modal-wnd-bg-color": "#eef",
    "--switch-on-color": "radial-gradient(farthest-corner at 7px 4px,#ffffff -25%,#8d45b5 25%,#673889 75%,#4b286a)",
    "--switch-off-color": "#cabbeb",
    "--switch-bg-color": "#8d45b544",
};
